import { render, staticRenderFns } from "./FileSharing.vue?vue&type=template&id=54aa26df&scoped=true&"
import script from "./FileSharing.vue?vue&type=script&lang=ts&"
export * from "./FileSharing.vue?vue&type=script&lang=ts&"
import style0 from "./FileSharing.vue?vue&type=style&index=0&id=54aa26df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa26df",
  null
  
)

export default component.exports